<template lang="pug">
.container.grid-lg.my-2.py-2
  fieldset(:disabled="loading || !assunto")
    form(@submit.prevent="save" v-if='assunto')
      .panel
        .panel-header
          .h5 Nova OS-m para outro departamento
        .panel-body.columns
          form-group.column.col-12(:label="'ordem_servico.assunto' | tModel")
            .h5 {{ assunto.descricao }}
          form-group.column.col-12(:label="'ordem_servico.obs' | tModel" :validation="$v.form.obs")
            textarea.form-input(v-model="$v.form.obs.$model" rows="4")
          .column.col-12.divider.text-center(data-content='Dados opcionais')
          form-group.column.col-12(:label="'ordem_servico.cadastro' | tModel" :validation="$v.form.cadastro_id")
            cadastro-picker(v-model="$v.form.cadastro_id.$model")
          form-group.column.col-3.col-sm-12(:label="'ordem_servico.protocolo_tipo' | tModel" :validation="$v.form.protocolo_tipo")
            select-protocolo-tipo(v-model="$v.form.protocolo_tipo.$model")
          form-group.column.col-3.col-sm-12(:label="'ordem_servico.protocolo_numero' | tModel" :validation="$v.form.protocolo_numero")
            int.form-input(v-model="$v.form.protocolo_numero.$model")
          form-group.column.col-3.col-sm-12(:label="'ordem_servico.protocolo_ano' | tModel" :validation="$v.form.protocolo_ano")
            year.form-input(v-model="$v.form.protocolo_ano.$model")
          form-group.column.col-3.col-sm-12(:label="'ordem_servico.protocolo_data' | tModel" :validation="$v.form.protocolo_data")
            datepicker(v-model="$v.form.protocolo_data.$model")
        .panel-footer.text-right
          button.btn.btn-primary(:disabled="$v.$invalid" :class="loading") Salvar
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import toastErrors from '@/lib/errors/toastErrors'

export default {
  vuex: {
    'compartilhado/assuntos': {
      state: ['list'],
      actions: ['fetchList'],
    },
    'compartilhado/servicos': {
      getters: ['loading'],
      actions: ['fetchCreate'],
    },
  },

  data() {
    return {
      form: {
        situacao: 'aguardando_distribuir',
        cadastro_id: null,
        protocolo_tipo: 'geral',
        protocolo_numero: 0,
        protocolo_ano: 0,
        protocolo_data: '',
        obs: '',
      },
    }
  },

  methods: {
    async save() {
      try {
        const params = { ...this.form, assunto_id: this.assuntoId }
        const { id } = await this.fetchCreate(params)
        this.$toaster.success('Salvo com sucesso')
        this.$router.replace({
          name: 'app.osm.compartilhado.servicos.show',
          params: { id },
        })
      } catch (e) {
        toastErrors(e)
      }
    },
  },

  computed: {
    assuntoId() {
      return Number(this.$route.params.assunto_id)
    },
    assunto() {
      if (!this.list) return null
      return this.list.find(a => a.id === this.assuntoId)
    },
  },

  validations: {
    form: {
      obs: { required, minLength: minLength(10), maxLength: maxLength(4000) },
      situacao: {},
      cadastro_id: {},
      protocolo_tipo: {},
      protocolo_numero: {},
      protocolo_ano: {},
      protocolo_data: {},
    },
  },

  async created() {
    if (!this.list || this.list.length === 0) {
      await this.fetchList()
    }
  },
}
</script>
